module.exports = require("@noble/hashes/_assert");